import { cn } from '../../../lib/cn'
import { CAMPOS_DO_PLANO } from '../../../lib/glossario'
import { ARTEFATOS_EXIGIDOS } from './pendencias'
import type { FormularioNovaGmud } from './esquema'

/**
 * O plano, relido.
 *
 * Campo não preenchido aparece dito com todas as letras, em vez de sumir — do mesmo jeito que na
 * tela de detalhe. Uma conferência que só mostra o que foi escrito parece completa por construção,
 * e o buraco só apareceria quando o comitê recusasse o envio.
 *
 * O texto sai com `whitespace-pre-line`: o usuário escreve passo a passo em linhas, e colapsar as
 * quebras transformaria um roteiro de implantação num parágrafo único.
 *
 * @param props o que foi preenchido até aqui
 * @returns a lista de conferência da etapa 2
 */
export function ResumoDoPlano({ valores }: { valores: FormularioNovaGmud }) {
  return (
    <dl className="space-y-5">
      {CAMPOS_DO_PLANO.map((campo) => {
        const texto = valores[campo.campo]?.trim()
        const exigido = ARTEFATOS_EXIGIDOS.includes(campo.campo)
        return (
          <div key={campo.campo}>
            <dt className="text-sm font-semibold text-slate-800">{campo.rotulo}</dt>
            <dd className={cn('mt-1 text-sm', texto ? 'whitespace-pre-line text-slate-700' : 'text-slate-500')}>
              {texto ?? (
                <span className={exigido ? 'font-medium text-laranja-700' : 'italic text-slate-400'}>
                  {exigido ? 'Ainda não preenchido — exigido para enviar ao comitê' : 'Ainda não preenchido'}
                </span>
              )}
            </dd>
          </div>
        )
      })}
    </dl>
  )
}
